import styled from "styled-components";
import { Button, Layout, Typography, Menu } from "antd";
import {
  GRAY_25,
  WHITE,
  GRAY_90,
  GRAY_600,
  SEC_FONT_GREY,
  GRAY_100,
  DARK_BLACK,
  BLACK,
  PURPLE_HEART,
  LIGHT_PURPLE,
  PRIMARY_600,
  ERROR_50,
  ERROR_600,
  GRAY_900,
  GRAY_300
} from "../../constant/colors";
import { sizes, fontWeights } from "../../constant/styles";

const { Sider, Header, Content, Footer } = Layout;
const { Text } = Typography;
const HEADER_BUTTON_SIZE = "30px";
const SIDEBAR_WIDTH = "238px";
const COLLAPSED_HEADER_HIGHT = "70px";

const CollapsibleButton = styled(Button)`
  font-size: ${sizes.medium_large};
  size: ${HEADER_BUTTON_SIZE};
  background: ${PURPLE_HEART};
  z-index: 10;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 20px;
  right: 0;
  width: 30;

  border-radius: 60px;
  padding: 10px 8px 10px 8px
  gap: 10px;

  transform: translateX(50%);

  .anticon {
    background-color: ${PURPLE_HEART} !important;
    color: ${WHITE} !important;
    border-radius: 60px;
  }

  &:hover {
    background: ${PURPLE_HEART} !important;
  }

  &:disabled {
    opacity: 0.3;
  }

  :focus {
    background: ${PURPLE_HEART};
  }

  :active {
    border: 3px solid ${PURPLE_HEART} !important;
    background: ${PURPLE_HEART} !important;
  }
`;

const StartNewConversationButton = styled(Button)`
  width: 100%;
  z-index: 100;
  font-size: ${sizes.medium};
  size: ${HEADER_BUTTON_SIZE};
  border-radius: 10px;
  color: ${WHITE} !important;
  font-weight: ${fontWeights.semibold};
  font-family: "Open Sans";
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${PRIMARY_600};
  paragraph-spacing: 16px;
  box-shadow: 0px 1px 2px 0px ${GRAY_900};
  padding: 10px 20px;
  &:hover {
    background: ${PRIMARY_600} !important;
  }

  &:disabled {
    opacity: 0.3;
  }

  :focus {
    background: ${PRIMARY_600};
  }

  :active {
    border: 3px solid ${PRIMARY_600} !important;
    background: ${PRIMARY_600} !important;
  }
`;

const CustomSider = styled(Sider)`
  background: ${WHITE};
  border: 1px;
  flex-direction: column;
  transition: width 0.3s ease;
  height: 100%;
  display: flex;
  flex-shrink: 0;
  border-right: 1px solid ${GRAY_90};
  position: relative;
`;

const LoadMoreButtonStyle = styled(Button)`
  font-size: ${sizes.small};
  font-weight: ${fontWeights.bold};
  font-family: "Open Sans";
  justify-content: center;
  display: flex;
  padding: 10px;
  width: 100%;
`;

const CustomLayout = styled(Layout)`
  position: relative;
  width: 95%;
  max-height: 83vh;
  margin: 0px 15px 0px 15px;
  background: ${WHITE};
  border-radius: 10px;
  padding: 10px 15px 0px 15px;
`;

const ChatWidgetLayoutStyle = styled(Layout)`
  position: relative;
`;

const ChatContentStyle = styled(Content)`
  overflow: hidden;
  transition: width 0.3s ease, height 0.3s ease;
  width: 100%;
  position: relative;
  background: ${WHITE};
  display: flex;
  justify-content: center;
`;

const ChatFooterStyle = styled(Footer)`
  padding: 0;
  padding-bottom: 2px;
  text-align: center;
  background: ${WHITE};
`;
const FooterTextStyle = styled(Text)`
  font-size: ${sizes.small};
  font-weight: 400;
  color: ${SEC_FONT_GREY};
  font-family: "Open Sans";
  text-align: center;
`;

const AIChatNameTextStyle = styled(Text)`
  width: 130px;
  height: 31px;
  font-size: ${sizes.medium};
  font-weight: ${fontWeights.semibold};
  color: ${PURPLE_HEART};
  font-family: "Open Sans";
  line-height: 150%;
  paragraph-spacing: 16px;
  background: ${LIGHT_PURPLE};
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 5px 8px;
`;
const ChatSiderMenuStyle = styled(Menu)`
  display: flex;
  overflow-y: auto;
  display: block;
  max-height: 350px;

  .ant-menu-item-group-title {
    font-size: 14px;
    font-weight: 600;
    color: ${DARK_BLACK};
    border-bottom: 1px solid ${GRAY_90};
    height: 50px;
    font-family: "Open Sans";
    padding: 10px 20px;
  }
  .ant-menu-item {
    font-size: ${sizes.small};
    font-weight: ${fontWeights.regular};
    font-family: "Open Sans";
    color: ${DARK_BLACK};
    transition: background 0.3s, color 0.3s;
    border-radius: 12px;
    margin: 5px;
    gap: 10px;
  }

  .ant-menu-item:hover,
  .ant-menu-item-active,
  .ant-menu-item-ligth,
  .ant-menu-item-selected {
    background: ${GRAY_100} !important;
    color: ${DARK_BLACK};
    border-radius: 12px;
  }
  .ant-menu-item:focus {
    background: ${GRAY_100};
    color: ${DARK_BLACK};
  }

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${GRAY_90};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${GRAY_600};
  }
`;

const DeepChatStyle = {
  border: "none",
  width: "100%",
  height: "100%"
};

const margin = "2%";
const DeepChatMessagesStyle = {
  default: {
    shared: {
      bubble: {
        maxWidth: "92%",
        marginTop: "10px",
        marginBottom: "10px",
        color: DARK_BLACK,
        borderRadius: "12px"
      }
    },
    ai: {
      bubble: {
        backgroundColor: GRAY_25,
        marginLeft: margin
      }
    },
    user: { bubble: { backgroundColor: GRAY_100, marginRight: margin, padding: "15px" } }
  },
  html: {
    shared: {
      bubble: {
        backgroundColor: "unset",
        marginTop: "0px"
      }
    },
    ai_error: {
      bubble: {
        backgroundColor: ERROR_50,
        lineHeight: "150%",
        color: ERROR_600,
        fontSize: "15px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        padding: "12px 16px",
        margin: "0 auto",
        width: "fit-content",
        fontWeight: "400"
      }
    }
  }
};

const DeepChatSubmitButtonStyle = {
  position: "relative",
  right: "40px",
  top: "30px"
};

const DeepChatSubmitButtonLoadingStyle = {
  position: "relative",
  right: "48px",
  top: "24px"
};

const DeepChatTextInputContainerStyle = {
  background: GRAY_100,
  height: "40px",
  padding: "10px",
  lineHeight: "25px",
  borderRadius: "10px",
  border: "0",
  boxShadow: "none"
};

const DeepChatTextInputPlaceholderStyle = {
  color: SEC_FONT_GREY
};

const SuggestedQuestionsCardStyle = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  borderRadius: "12px",
  border: "1px solid #5416BF0D",
  boxShadow: "0px 10px 40px 0px #5416BF0F",
  padding: "16px",
  fontWeight: "520",
  fontSize: "14px",
  fontFamily: "Open Sans",
  background: "#FFFFFF",
  cursor: "pointer",
  color: GRAY_900,
  letterSpacing: "0"
};

const SuggestedQuestionsCardBodyStyle = { padding: "0", height: "100%", display: "flex", flexDirection: "column" };

const SuggestedQuestionsCardTopSectionStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "30%"
};

const SuggestedQuestionsCardBottomSectionStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "70%"
};

const SuggestedQuestionsCardQuestionsContainerStyle = {
  overflow: "auto"
};

const SuggestedQuestionsCardIconStyle = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  size: "20px",
  height: "20px"
};

const SuggestedQuestionsCardTitleContainerStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start"
};

const SuggestedQuestionsCardTitleStyle = {
  fontSize: "20px",
  fontWeight: "600",
  lineHeight: "150%",
  fontFamily: "Open Sans"
};

const SuggestedQuestionsCardThemeStyle = {
  fontSize: "12px",
  fontWeight: "400",
  lineHeight: "150%",
  fontFamily: "Open Sans"
};

const SuggestedQuestionsCardDividerStyle = {
  backgroundColor: "rgba(0 0 0 / 0.08)",
  height: "1px",
  marginTop: "10px"
};

const SuggestedQuestionsCardAskNewQuestionContainerStyle = {
  display: "flex",
  justifyContent: "center",
  cursor: "pointer",
  borderBottom: "2px solid #5416BF",
  padding: "6px 5px",
  zIndex: 1,
  touchAction: "manipulation",
  userSelect: "none"
};

const SuggestedQuestionsCardAskNewQuestionStyle = {
  fontSize: "16x",
  fontWeight: "700",
  height: "20px",
  display: "flex",
  paddingLeft: "0",
  fontFamily: "Open Sans",
  color: "#5416BF",
  pointerEvents: "none"
};

const SuggestedQuestionsCardQuestionStyle = {
  whiteSpace: "normal",
  height: "auto",
  backgroundColor: "#F9FAFB",
  borderRadius: "10px",
  marginTop: "10px",
  padding: "10px",
  cursor: "pointer",
  fontWeight: "400",
  fontSize: "14px",
  fontFamily: "Open Sans",
  border: 0,
  textAlign: "left"
};

const IntroPanelContainerStyle = {
  width: "83%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start"
};

const IntroPanelHelloTextStyle = {
  fontSize: "36px",
  fontWeight: "700",
  fontFamily: "Open Sans",
  lineHeight: "44px",
  letterSpacing: "-2%",
  color: BLACK
};

const IntroPanelHowCanIHelpTextStyle = {
  fontSize: "36px",
  fontWeight: "300",
  fontFamily: "Open Sans",
  color: BLACK,
  lineHeight: "30px",
  letterSpacing: "0"
};

const IntroPanelSelectCategoryTextStyle = {
  fontSize: "24px",
  fontWeight: "300",
  fontFamily: "Open Sans",
  color: BLACK,
  lineHeight: "30px",
  letterSpacing: "0",
  marginTop: "5px"
};

const IntroPanelQuestionsContainerStyle = {
  marginTop: "30px",
  display: "flex",
  gap: "20px",
  height: "45vh"
};

const HeaderTextStyle = styled(Text)`
  font-size: 12px;
  font-weight: 400;
  font-family: "Open Sans";
  color: ${GRAY_900};
  line-height: 150%;
  letter-spacing: 0;
`;

const ChatHeaderStyle = styled(Header)`
  position: relative;
  z-index: 1;
  padding: 10px 20px;
  background: ${WHITE};
  height: auto;
  ${({ collapsed }) => `
    height: ${collapsed ? COLLAPSED_HEADER_HIGHT : "auto"};
    border-bottom: ${!collapsed ? "none" : `1px solid ${GRAY_90}`};

  `};
`;

const AITeamMateTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 7px 10px;
  gap: 10px;
  width: 186px;
  height: 36px;
  background: ${LIGHT_PURPLE};
  border-radius: 8px;
  position: relative;
`;

const AITeamMateIcon = styled.div`
  width: 14px;
  height: 14px;
  font-size: 14px;
  font-weight: 600;
`;

const AITeamMateTextStyle = styled(Text)`
  width: 90px;
  height: 21px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: ${PURPLE_HEART};
  flex: none;
  order: 1;
  flex-grow: 0;
`;

const BetaTagContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center !important;
  padding: 4px 8px;
  width: 42px;
  height: 22px;
  background: ${PURPLE_HEART};
  border-radius: 100px;
  flex: none;
  order: 2;
  flex-grow: 0;
`;

const BetaTagText = styled(Text)`
  width: 26px;
  height: 14px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 14px;
  text-align: center;
  text-transform: uppercase;
  color: ${WHITE} !important;
  flex: none;
  margin-left: 0 !important;
  order: 0;
  flex-grow: 0;
`;

const BetaTagStyle = styled.span`
  background-color: #6f2cff;
  color: white;
  font-size: 12px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 16px;
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FeedbackFormContainerStyle = {
  boxSizing: "border-box",
  height: "100px",
  width: "calc(50vw + 20px)",
  border: "1px solid #E4E7EC",
  borderRadius: "10px",
  flex: "none",
  order: 2,
  flexGrow: 0,
  position: "relative",
  marginTop: "20px"
};

const FeedbackFormTitleStyle = {
  position: "absolute",
  height: "12px",
  left: "20px",
  top: "20px",
  fontFamily: "Open Sans",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "12px",
  lineHeight: "100%",
  textTransform: "uppercase",
  color: BLACK
};

const FeedbackFormContentStyle = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  padding: "0px",
  gap: "16px",
  position: "absolute",
  width: "calc(50vw - 16px)",
  height: "38px",
  left: "20px",
  top: "42px"
};

const FeedbackFormInputStyle = {
  flex: 1,
  height: "38px",
  borderBottom: `1px solid ${GRAY_300}`,
  borderTop: "none",
  borderLeft: "none",
  borderRight: "none",
  borderRadius: 0,
  fontFamily: "Open Sans",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "150%",
  color: GRAY_600
};

const FeedbackFormSendButtonStyle = {
  width: "54px",
  height: "31px",
  background: WHITE,
  border: `1px solid ${GRAY_90}`,
  borderRadius: "10px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  padding: "5px 10px",
  gap: "10px",
  cursor: "pointer"
};

const FeedbackFormSendButtonTextStyle = {
  width: "34px",
  height: "21px",
  fontFamily: "Open Sans",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "150%",
  color: BLACK
};

const FeedbackFormCloseButtonStyle = {
  position: "absolute",
  cursor: "pointer",
  right: "6px",
  top: "6px",
  border: "none",
  background: "transparent",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

const FeedbackThankYouContainerStyle = {
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "20px",
  marginTop: "20px",
  gap: "5px",
  width: "fit-content",
  height: "64px",
  border: "1px solid #E4E7EC",
  borderRadius: "10px"
};

const FeedbackThankYouTextStyle = {
  width: "433px",
  height: "18px",
  fontFamily: "Open Sans",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "12px",
  lineHeight: "150%",
  color: BLACK
};

const FeedbackThankYouIconStyle = {
  width: "24px",
  height: "24px",
  background: "#ECFDF3",
  border: "2px solid #F6FEF9",
  borderRadius: "90px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

const FeedbackFormWrapperStyle = {
  marginTop: "8px"
};

export {
  HeaderTextStyle,
  ChatHeaderStyle,
  SuggestedQuestionsCardBodyStyle,
  SuggestedQuestionsCardQuestionsContainerStyle,
  SuggestedQuestionsCardTopSectionStyle,
  SuggestedQuestionsCardBottomSectionStyle,
  SuggestedQuestionsCardTitleContainerStyle,
  SuggestedQuestionsCardIconStyle,
  SuggestedQuestionsCardStyle,
  SuggestedQuestionsCardTitleStyle,
  SuggestedQuestionsCardThemeStyle,
  SuggestedQuestionsCardDividerStyle,
  SuggestedQuestionsCardAskNewQuestionStyle,
  SuggestedQuestionsCardAskNewQuestionContainerStyle,
  SuggestedQuestionsCardQuestionStyle,
  IntroPanelContainerStyle,
  AIChatNameTextStyle,
  BetaTagStyle,
  AITeamMateTitleContainer,
  AITeamMateIcon,
  AITeamMateTextStyle,
  BetaTagContainer,
  BetaTagText,
  DeepChatStyle,
  DeepChatMessagesStyle,
  DeepChatTextInputContainerStyle,
  DeepChatTextInputPlaceholderStyle,
  DeepChatSubmitButtonStyle,
  DeepChatSubmitButtonLoadingStyle,
  ChatSiderMenuStyle,
  IntroPanelHelloTextStyle,
  IntroPanelHowCanIHelpTextStyle,
  IntroPanelSelectCategoryTextStyle,
  IntroPanelQuestionsContainerStyle,
  CustomSider,
  CollapsibleButton,
  StartNewConversationButton,
  CustomLayout,
  SIDEBAR_WIDTH,
  ChatWidgetLayoutStyle,
  ChatContentStyle,
  ChatFooterStyle,
  FooterTextStyle,
  LoadMoreButtonStyle,
  FeedbackFormContainerStyle,
  FeedbackFormTitleStyle,
  FeedbackFormContentStyle,
  FeedbackFormInputStyle,
  FeedbackFormSendButtonStyle,
  FeedbackFormSendButtonTextStyle,
  FeedbackFormCloseButtonStyle,
  FeedbackThankYouContainerStyle,
  FeedbackThankYouTextStyle,
  FeedbackThankYouIconStyle,
  FeedbackFormWrapperStyle
};
